import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';
import { HttpEventType } from '@angular/common/http';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-manage-events',
  templateUrl: './manage-events.component.html',
  styleUrls: ['./manage-events.component.scss'],
})
export class ManageEventsComponent implements OnInit {
  @ViewChild('AssignOption') AssignOptionModal: ElementRef;
  @ViewChild('addEvent') addEventModal: ElementRef;

  @Input() hideAll: boolean = false;
  @Output() updated = new EventEmitter<string>();

  public editMode: boolean;
  public commonModal: any;
  public allAds: Array<any> = [];
  public subRegionList: Array<any> = [];
  public selectedAds: any;
  public imageBase64: string | ArrayBuffer;
  public imgUrl = environment.ImageUrl;

  public form: FormGroup = new FormGroup({
    name: new FormControl(''),
    description: new FormControl(''),
    eventDate: new FormControl(''),
    url: new FormControl('', [Validators.required]),
    image: new FormControl(null, [Validators.required]),
  });

  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    public commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this._getAdsList();
  }

  public openProductCharForAddEdit(selected: any = null) {
    if (selected) {
      this.editMode = true;
      this.selectedAds = selected;
      this.form.patchValue({
        name: selected?.name,
        description: selected?.description,
        eventDate: new Date(selected?.eventDate),
        image: selected?.image,
        url: selected?.url,
      });
    } else {
      this.form.reset();
      this.imageBase64 = null;
    }
    this.commonModal = this.modalService.open(this.addEventModal, {
      // backdrop: 'static',
      windowClass: 'my-upload-event-modal',
    });
  }

  public openModal(selectedArticle) {
    let selectedId = selectedArticle.subRegion ? selectedArticle.subRegion.split('|') : [];
    this.subRegionList = structuredClone(this.commonService.subRegionLists.map((j) => {
      let output = JSON.parse(JSON.stringify(j));
      output['checked'] = selectedId.includes(j.subRegionId.toString());
      return output;
    }));

    this.selectedAds = selectedArticle;
    this.commonModal = this.modalService.open(this.AssignOptionModal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
    });
  }

  assignArticles() {
    if (this.selectedAds) {
      let subRegionStr = this.subRegionList
        .filter((i) => i.checked)
        .map((i) => i.subRegionId)
        .join('|');

      let formData = new FormData();

      formData.append('id', this.selectedAds?.id);
      formData.append('name', this.selectedAds.name);
      formData.append('description', this.selectedAds.description);
      formData.append('eventDate', this.selectedAds.eventDate);
      formData.append('image', this.selectedAds.image);
      formData.append('url', this.selectedAds.url);

      formData.append('subRegion', subRegionStr ? subRegionStr : 'default');

      this.auth.addEvents(formData).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this._getAdsList();
        this.selectedAds = null;
      });
    } else {
      this.toastr.error('InValid Id!');
    }
  }

  private _getAdsList() {
    this.auth.getAllEvents().subscribe((resp: ApiResponse) => {
      let output = [];
      for (let i of resp.body) {
        output.push({
          ...i,
          ...{
            categoryList:
              i.category && i.category.includes('|')
                ? i.category.split('|')
                : [i.category],
            subRegionList: i.subRegion && i.subRegion.includes('|') ? i.subRegion.split('|').map((i) => this.commonService.getSubregionName(i)) : [i.subRegion],
          },
        });
      }
      this.allAds = output;
    });
  }

  uploadProgress: number = 0;
  public save(): void {
    if (this.form.valid) {
      let formData = new FormData();
      typeof this.form.get('image').value == 'string'
        ? ''
        : formData.append('image', this.form.get('image').value);

      formData.append('name', this.form.get('name').value);
      formData.append('description', this.form.get('description').value);
      formData.append('subRegion', 'default');
      formData.append(
        'eventDate',
        new Date(this.form.get('eventDate').value).getTime().toString()
      );
      formData.append('url', this.form.get('url').value);
      formData.append('registeredMembers', '[]');

      if (this.selectedAds) {
        formData.append('id', this.selectedAds?.id);
      }
      this.uploadProgress = 0;

      this.auth
        .addEvents(formData, {
          reportProgress: true,
          observe: 'events',
        })
        .subscribe(
          (resp: any) => {
            if (resp.type === HttpEventType.UploadProgress) {
              // Update progress percentage
              this.uploadProgress = Math.round(
                (100 * resp.loaded) / resp.total
              );
            } else if (resp.type === HttpEventType.Response) {
              this.toastr.success(resp.body.message);
              this.modalDismissAll();
              this._getAdsList();
              this.updated.emit('updated');
              this.selectedAds = null;
              this.uploadProgress = 0;
            }
          },
          ({ error }: any) => {
            this.toastr.error(error.message);
          }
        );
    } else {
      this.toastr.error('Form is Invalid fill ALL ');
    }
  }

  public modalDismissAll() {
    this.modalService.dismissAll();
    this.selectedAds = null;
  }

  public saveProductCharSelectedImage(event) {
    this.selectedAds ? (this.selectedAds.image = null) : '';
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.form.get('image').setValue(file);
    };
    fileReader.readAsDataURL(file);
  }

  public deleteAds(id) {
    this.auth.deleteEvents(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAdsList();
    });
  }
}
